import { REGISTER_USER } from '@redux/types';

const INITIAL_STATE = {
  loading: false,
  payload: null,
  error: null
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case REGISTER_USER.IN_PROGRESS:
      return {
        ...state,
        loading: true
      };

    case REGISTER_USER.SUCCESS:
      return {
        ...state,
        payload: action.payload,
        loading: false
      };

    case REGISTER_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return { ...state };
  }
};
